import Select from 'react-select'
import React from 'react'

const selectStyles = {
  control: styles => ({
    ...styles,
    width: '200px',
    borderRadius: '50px',
  }),
  menu: styles => ({
    ...styles,
    zIndex: 9999999999,
  }),
}

export default function SelectInput(props) {
  const { val, ...rest } = props

  return (
    <Select
      styles={selectStyles}
      classNamePrefix='custom-select'
      components={{
        IndicatorSeparator: null,
      }}
      {...rest}
    />
  )
}
